import { useState, useEffect, useRef, useContext } from "react";

// ------------------ COMPONENTES DE PRIMEREACT--------------------------
import { OverlayPanel } from "primereact/overlaypanel";
import { Button } from "primereact/button";
import { InputText } from "primereact/inputtext";

// ------------------ COMPONENTES DE BASE--------------------------
import AgGrid from "../../../../../../Base/Components/Tables/AgGrid/AgGrid";
import { AuthContext } from "../../../../../../Base/Context/AuthContext/AuthContext";

// ------------------ CONSULTAS A LA API--------------------------
import { DetallesIngresosBodega } from "../../../../../../API/Suministros/IngresosBodega/IngresosBodegaDetalleRequest";
import { alignProperty } from "@mui/material/styles/cssUtils";

const RequisaOverlayPanelDetalle = ({
    close, rowData, onChange, MateriaPrima
}) => {
    const op = useRef(null);
    const buttom = useRef(null);
    const { userAuth } = useContext(AuthContext);

  const [loading, setLoading] = useState(false);
  const [ingresosBodega, setIngresosBodega] = useState([]);

  const fetchData = async () => {
    try {
      const response = await DetallesIngresosBodega();
      // let a = MateriaPrima === 1 ? true : null
      let IdTipo = MateriaPrima === 1 ? 2 : 1

      const data = response.filter((i) => i?.IdTipoIngreso === IdTipo)
      setIngresosBodega(response);
    } catch (error) {
      console.error("Error al llamar a la API:", error);
    }
  };

  const columns = [
    {
      header: "Código",
      headerEn: "Code",
      field: "CodigoProducto",
      className: 'Xsmall',
    },
    {
      header: "Producto",
      headerEn: "Product",
      field: "NombreProducto",
      flex: 1,
      minWidth: 200,
    },
    {
      header: "Tipo Producto",
      headerEn: "Product Type",
      field: "NombreCategoria",
      className: 'small',
    },
    {
      header: "Categoría",
      headerEn: "Category",
      field: "NombreSubcategoria",
      className: 'small',
    },
    {
      header: "Sub Categoría",
      headerEn: "Sub Category",
      field: "NombreTipoProducto",
      className: 'small',
    },
    {
      header: "Inventario",
      headerEn: "Subcategory Name",
      field: "Inventario",
      Format: 'Currency',
      Sumary: 'sum',
      className: 'small',
      frozen: true,
      alignFrozen: 'right',
    },
    {
      header: "Bodega",
      headerEn: "Werehouse",
      field: "NombreBodega",
    },
  ];
  const table = {
    Data: ingresosBodega,
    loading: loading,
    Columns: columns,
    onCellClicked: (e) => onChange(e, rowData),
  };

  useEffect(() => {
    fetchData();
  }, []);

  return (
    <div style={{ maxWidth: "50vw" }}>
      <div className="p-inputgroup">
        <InputText
          value={rowData.Requisa}
          disabled
          placeholder="Producto"
          onClick={(e) => op.current.toggle(e)}
        />
        <Button
          ref={buttom}
          icon="pi pi-chevron-down"
          style={{ padding: "0.5rem 0.3rem" }}
          type="button"
          onClick={(e) => op.current.toggle(e)}
        />
      </div>

      <OverlayPanel
        ref={op}
        showCloseIcon
        dismissable={false}
        className="OverPanelProductos"
        onHide={close}
      >
        <div style={{ width: 1300, height: 300 }}>
          <AgGrid table={table} />
        </div>
      </OverlayPanel>
    </div>
  );
};

export default RequisaOverlayPanelDetalle;
